import PropTypes from "prop-types";
import Animate from "rc-animate";
import React from "react";
import FacebookSlideshow from "./FacebookSlideShow";

class SlideShow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      index: 0
    };
  }

  next() {
    var index = this.state.index;
    index++;
    if (index >= this.props.items.length) {
      index = 0;
      if (this.props.endOfSlidesCallback) {
        this.props.endOfSlidesCallback();
      }
    }
    this.setState({
      index: index
    });
  }

  onSlideShowEnd() {
    this.next();
  }

  componentDidMount() {}

  render() {
    const callback = () => this.onSlideShowEnd();
    let delayTime = Number(this.props.delay) * 1000;
    let item = this.props.items && this.props.items[this.state.index];
    let bgStyle = {};

    if (this.props.bgColor && this.props.color) {
      bgStyle = {
        borderColor: this.props.bgColor,
        backgroundColor: "#e8ebee"
      };
    }

    if (item === undefined) {
      return (
        <div className="slideshow-container slide-preload" style={bgStyle}>
          <span className="load-message">Please wait ...</span>
        </div>
      );
    }

    var pageLikesInfo = this.props.pageLikesInfo;

    return (
      <div className="slideshow-container color-text-body" style={bgStyle}>
        <Animate transitionLeave transitionAppear transitionName="fade">
          <FacebookSlideshow
            data={item}
            pageLikesInfo={pageLikesInfo}
            profilePic={this.props.profilePic}
            name={this.props.name}
            duration={delayTime}
            onSlideEnded={callback}
            max_play_durations={this.props.max_play_durations}
            color={this.props.color}
            bgcolor={this.props.bgColor}
            facebook_access={this.props.facebook_access}
            fullscreen={this.props.fullscreen}
            preload={this.props.preload}
            theme={this.props.theme}
            displayQr={this.props.displayQr}
            mute={this.props.mute}
          />
        </Animate>
      </div>
    );
  }
}

SlideShow.propTypes = {
  bgColor: PropTypes.string,
  color: PropTypes.string,
  delay: PropTypes.number,
  displayQr: PropTypes.bool,
  endOfSlidesCallback: PropTypes.func,
  facebook_access: PropTypes.string,
  fullscreen: PropTypes.string,
  items: PropTypes.array,
  max_play_durations: PropTypes.number,
  mute: PropTypes.bool,
  name: PropTypes.string,
  pageLikesInfo: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    fan_count: PropTypes.number,
    link: PropTypes.string
  }),
  preload: PropTypes.bool,
  profilePic: PropTypes.string,
  shortName: PropTypes.string,
  theme: PropTypes.string
};

export default SlideShow;
